import script from "./PaginationBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationBar.vue?vue&type=script&setup=true&lang=js"

import "./PaginationBar.vue?vue&type=style&index=0&id=6eca506a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eca506a"]])

export default __exports__